import AbstractChannel from './AbstractChannel'

export default class ParkWhiz extends AbstractChannel {

  name = 'parkwhiz'
  title = 'ParkWhiz'
  titleShort = 'ParkWhiz'
  color = '#9edae5'

  supportedFeatures = ['blackouts']

}
